function Footer(){
  return (
    <div className="footer">
      <p className="textright">Last updated 4/2/2026</p>
    </div>)
}

export default Footer
;
